module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('base-header')], 1), _vm._v(" "), _c('div', [_c('left-menu'), _vm._v(" "), _c('div', {
    staticClass: "rightContent",
    attrs: {
      "height": _vm.height
    }
  }, [_c('router-view'), _vm._v(" "), _c('msg')], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-a159cc32","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/base/homePage.vue
// module id = 592
// module chunks = 1 2 3 4 5 6 7 8